// https://github.com/turbolinks/turbolinks/issues/272
// support remote get forms ... since turbolinks fails to do this properly
export default function turbolinksGetForms() {
    $(document).on('submit', 'form[method=get][data-turbolinks-form=true]', function (e) {
        e.preventDefault();
        let form = $(this);
        Turbolinks.visit(form.attr("action") + '?' + form.serialize());
    });
}